import { FieldProps } from "formik";
import moment from "moment-timezone";
import "moment/locale/da";
import "moment/locale/en-au";
import "moment/locale/en-ca";
import "moment/locale/en-gb";
import "moment/locale/en-ie";
import "moment/locale/en-il";
import "moment/locale/en-nz";
import "moment/locale/en-sg";
import "moment/locale/es-us";
import "moment/locale/my";
import "moment/locale/se";
import React, { useEffect, useState } from "react";

export interface DateTimePickerProps {
	dateRef?: React.RefObject<any>;
	field: FieldProps["field"];
	form: FieldProps["form"];
	id: string;
	name: string;
	timeCaption?: string;
	timeRef?: React.RefObject<any>;
	[key: string]: any;
	min?: string;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
	dateRef,
	field,
	form,
	id,
	name,
	timeCaption,
	timeRef,
	className,
	min,
	...props
}) => {
	const [dateFocused, setDateFocused] = useState(false);
	const [timeFocused, setTimeFocused] = useState(false);
	const [date, setDate] = useState(field.value ? moment.utc(field.value).format("YYYY-MM-DD") : undefined);
	const [time, setTime] = useState(field.value ? moment.utc(field.value).format("HH:mm") : undefined);

	const onChangeDate = (newDate: string | undefined) => {
		form.setFieldTouched(field.name);
		if (!newDate) {
			setDate("");
		} else {
			setDate(newDate);
		}
	};

	const onChangeTime = (newTime: string | undefined) => {
		form.setFieldTouched(field.name);
		if (!newTime) {
			setTime(undefined);
		} else {
			setTime(newTime);
		}
	};

	const setField = (newDate: string | undefined) => {
		if (!newDate) {
			form.setFieldValue(field.name, null);
		} else {
			const m = moment.utc(newDate);
			form.setFieldValue(field.name, m.isValid() ? m.toDate() : newDate);
		}
	};

	useEffect(() => {
		const timeParts =
			time && time.includes(":") ? time.split(":") : time && time.includes(".") ? time.split(".") : ["00", "00"];
		if (parseInt(timeParts[0]) < 10) {
			timeParts[0] = `0${parseInt(timeParts[0])}`;
		}
		if (parseInt(timeParts[1]) < 10) {
			timeParts[1] = `0${parseInt(timeParts[1])}`;
		}
		setField(date ? `${date} ${timeParts[0]}:${timeParts[1]}` : undefined);
	}, [date, time]);

	return (
		<div
			className={`datetime-picker ${className ? className : ""} ${dateFocused ? "date-active" : ""} ${
				timeFocused ? "time-active" : ""
			}`}
		>
			<div className="date-picker-container">
				<div className="field">
					<input
						ref={dateRef}
						disabled={props.disabled}
						type="date"
						id={`${id}-date`}
						value={date}
						min={min}
						onChange={(e) => onChangeDate(e.target.value)}
						onFocus={() => setDateFocused(true)}
						onBlur={() => {
							setDateFocused(false);
						}}
					/>
				</div>
			</div>
			<div className="time-picker-container">
				<div className="field">
					<input
						ref={timeRef}
						disabled={props.disabled}
						type="time"
						id={`${id}-time`}
						value={time}
						onChange={(e) => onChangeTime(e.target.value)}
						onFocus={() => setTimeFocused(true)}
						onBlur={() => setTimeFocused(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default DateTimePicker;
